var Grid = (function () {

    var $ = require('jquery');
    var self = {};

    self.$solutionItem = $('.solution-item');
    self.activeSolutionTrigger = 'active';

    self.$gridItem = $('.grid-item');

    self.init = function () {

        require('./../../../../build/node_modules/@components/magnific-popup/dist/jquery.magnific-popup.js');

        self.$solutionItem.on('click', function () {

            if (!$(this).hasClass(self.activeSolutionTrigger)) {

                $(this).closest('.ce-solutions-grid').find(self.$solutionItem).removeClass(self.activeSolutionTrigger);
                $(this).addClass(self.activeSolutionTrigger);

            } else {

                $(this).removeClass(self.activeSolutionTrigger);

            }

        });

        self.$gridItem.magnificPopup({
            type: 'inline'
        });

    };

    return self;

}());

module.exports = Grid;
